import { render, staticRenderFns } from "./BaseSimpleDropdown.vue?vue&type=template&id=80e38ddc&"
import script from "./BaseSimpleDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseSimpleDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseSimpleDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports